<template>
  <div class>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">发票信息</span>
      </div>
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <div style="width:500px">
          <el-form-item label="发票形式" prop="invoiceForm">
            <el-radio-group v-model="form.invoiceForm" style="width:100%">
              <el-radio label="0">增值税普通发票</el-radio>
              <el-radio label="1">增值税专用发票</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="公司名称" prop="companyName">
            <el-input v-model="form.companyName" placeholder="请输入公司名称" style="width:100%" />
          </el-form-item>
          <el-form-item label="税号" prop="taxNo">
            <el-input v-model="form.taxNo" placeholder="请输入税号" style="width:100%" />
          </el-form-item>
          <el-form-item label="开户行名称" prop="openBankName">
            <el-input v-model="form.openBankName" placeholder="请输入开户行名称" style="width:100%" />
          </el-form-item>
          <el-form-item label="开户行账号" prop="openBankAccountNo">
            <el-input v-model="form.openBankAccountNo" placeholder="请输入开户行账号" style="width:100%" />
          </el-form-item>
          <el-form-item label="注册地址" prop="registerAddress">
            <el-input v-model="form.registerAddress" placeholder="请输入注册地址" style="width:100%" />
          </el-form-item>
          <el-form-item label="电话" prop="mobile">
            <el-input v-model="form.mobile" placeholder="请输入电话" style="width:100%" />
          </el-form-item>
        </div>
      </el-form>
    </el-card>
    <div class="btns" style="margin-top:30px; display: flex; align-items: center; justify-content:center;">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="save">保存</el-button>
    </div>
  </div>
</template>

<script>
import { HOST, EV_HOST } from '@/utils/host'
const token = window.localStorage.getItem('token')
export default {
  name: 'Piaowuxiugai',
  components: {},
  data() {
    return {
      form: {
        invoiceForm: '0',
        companyName: '',
        taxNo: '',
        openBankName: '',
        openBankAccountNo: '',
        registerAddress: '',
        mobile: ''
      },
      rules: {
        invoiceForm: [
          { required: true, message: '请选择发票形式', trigger: 'blur' }
        ],
        companyName: [
          { required: true, message: '请输入公司名称', trigger: 'blur' }
        ],
        taxNo: [
          { required: true, message: '请输入税号', trigger: 'blur' }
        ],
        openBankName: [
          { required: true, message: '请输入开户行名称', trigger: 'blur' }
        ],
        openBankAccountNo: [
          { required: true, message: '请输入开户行账号', trigger: 'blur' }
        ],
        registerAddress: [
          { required: true, message: '请输入注册地址', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {},
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {
    this.form = this.$route.query.data
  }, // 生命周期 - 挂载之前
  beforeUpdate() {}, // 生命周期 - 更新之前
  updated() {}, // 生命周期 - 更新之后
  beforeDestroy() {}, // 生命周期 - 销毁之前
  destroyed() {}, // 生命周期 - 销毁完成
  activated() {},
  methods: {
    cancel() {
      this.$router.go(-1)
    },
    async save() {
      try {
        await Promise.all([
          this.$refs.form.validate()
        ])
      } catch (error) {
        return
      }
      const data = {
        id: this.form.id,
        invoiceForm: this.form.invoiceForm,
        companyName: this.form.companyName,
        taxNo: this.form.taxNo,
        openBankName: this.form.openBankName,
        openBankAccountNo: this.form.openBankAccountNo,
        registerAddress: this.form.registerAddress,
        mobile: this.form.mobile
      }
      this.$store.dispatch('form/handle', {
        url: '/business/tax/post',
        data: data,
        method: 'post',
        callback: resp => {
          this.$notify({
            title: '成功',
            message: '修改成功',
            type: 'success'
          })
          this.$router.go(-1)
        }
      })
    }
  } // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

  <style lang="less" src="" scoped>
  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  </style>



// WEBPACK FOOTER //
// src/views/ticketManagement/ticketModification.vue